/**
 * 网页调取调用APP方法
 * @param name 方法名，网页端与APP端约定的名称
 * @param params 向APP传递的参数
 */
export default function jsToApp(name, params = "") {
  window[name].postMessage(params);
}
